module.exports = __webpack_public_path__ + "static/lageplan_offentlicheverkehrsmittel-725f4011175c80827117979276d88e10.png";